import { MatDialog } from "@angular/material/dialog";
import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MatSelect } from "@angular/material/select";
import {
  HubConnection,
  HubConnectionBuilder,
  LogLevel,
} from "@microsoft/signalr";
import { SettingsService } from "src/app/services/settings.service";
import { filter, map, shareReplay, startWith, switchMap, takeUntil, tap } from "rxjs/operators";
import { StorageKeyEnum } from "src/app/core/StorageKeyEnum";
import { AuthService } from "./../../services/auth.service";
import { HeaderService } from "./header.service";
import { ProcessesDialogComponent } from "./processes-dialog/processes-dialog.component";
import { UpdatesDialogComponent } from "./updates-dialog/updates-dialog.component";
import { environment } from "src/environments/environment";
import { AccountType } from "src/app/models/account.model";
import { Subject, merge, of } from "rxjs";
import { DuplicateSkuComponent } from "../duplicate-sku/duplicate-sku.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackbarComponent } from "../snackbar/snackbar.component";
import { UnmappedSkusComponent } from "../unmapped-skus/unmapped-skus.component";
import { InventoryService } from "src/app/services/inventory.service";
import { LoginModel } from "src/app/models/login.model";
import { OrdersGridConfigService } from "src/app/data-grid/orders-grid-config.service";
import { Router } from "@angular/router";

import { ConfirmDialogComponent } from "../dialogs/confirm-dialog/confirm-dialog.component";
import { GridActionsService } from "src/app/data-grid/grid-actions.service";
import { ShipyardService } from "src/app/modules/shipyard/shipyard.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit, AfterViewInit,AfterViewChecked, OnDestroy {
  accounts;
  allMarketPlaces;
  selectedAccount: any;
  hasUpdates: boolean = true;
  accountTypes;
  @ViewChild("processingElement") processingElement: ElementRef;
  processes: PendingProcess[] = [];
  accountDropdownDisabled = false;
  allAccounts;
  @ViewChild(MatSelect) matSelect: MatSelect;
  private destroy$ = new Subject<void>();
  private hubConnection: HubConnection;
  selectedType: any;
  total: number = 0;
  showIcon: boolean = false;
  unMappedSku: any[]=[];
  userInfo:LoginModel;
  copied: boolean;
  titleWithShipment:any=null;
  settlementDetail: any;
  title:string;
  backendListRender = [
    { keyName: 'ID', key: 'settlementId', isHide: false, className: 'settlement_value' },
    { keyName: 'Date range', key: 'date', type: 'rangeDate', isHide: false },
    { keyName: 'Marketplace', key: 'marketplace', type: 'link', isHide: false },
    { keyName: 'Type', key: 'type', type: 'string', isHide: false },
    { keyName: 'status', key: 'status', type: 'status', isHide: false },
    { keyName: 'Total Payouts', key: 'totalAmount', type: 'currency', isHide: false },
    { keyName: 'Payout status', key: 'payoutStatus', type: 'status', isHide: false},
  ]
  itemStockWithNoMappingCount: number;
  mappedWithSyncOffCount:number=0;
  duplicateSkuCount:any[]=[];
  totalDuplicateSku:number = 0;
  skuNotOnSellerCount:number = 0;
  nonDeductedShipmentCount:number = 0;
  scanSetting:boolean=false;

  constructor(
    public headerService: HeaderService,
    private settingsService: SettingsService,
    private dialog: MatDialog,
    private authService: AuthService,
    private inventoryservice : InventoryService,
    private snackBar:MatSnackBar,
    private ordersGridConfigService:OrdersGridConfigService,
    public router:Router,
    private gridActionService:GridActionsService,
    private cdr: ChangeDetectorRef,
    private shipyardService : ShipyardService
  ) {
    this.authService.userInfo$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: LoginModel) => {
       this.userInfo=res;
      });
      
    this.headerService.RefreshDropdown$.pipe(takeUntil(this.destroy$)).subscribe((e)=> {
      if(e){
        this.getAccountByType();
      }
     });
  }

  ngAfterViewChecked(): void {
    this.headerService.accountsSelectDisabled.subscribe(
      (e: boolean) => {
        this.accountDropdownDisabled = e;
        this.cdr.detectChanges();
      }
    );
    this.headerService.showbellNotificationIcon$.subscribe((e:boolean)=> {
      this.showIcon = e
      this.cdr.detectChanges();
     })
     this.headerService.title.subscribe((res)=>{
      if(res){
        this.title = res;
        this.cdr.detectChanges();
      }
     })
  }

  ngOnInit(): void {
    this.getAccountByType();
  setTimeout(()=>{    
    this.getSetting();
    this.getLogisticsScanSetting();
    this.signalRWithoutToken();
    this.getItemStockWithNoMappingCount();
    this.getMappedWithSyncOffCount();  
    this.getDuplicateSkuCount();  
    this.getSkuNotOnSellerCount();
    this.getShipmentDeductionAlertCount();
    this.settingsService.GetSelectedPrinter().subscribe((printer: any[]) => {
      this.gridActionService.printer = printer.find((x) => x.printerType === 1);
    });
  },100);
    const connection = (this.hubConnection = new HubConnectionBuilder()
      .withUrl(
        `${environment.apiUrl}/hub/signalr?access_token=${this.authService.getToken()}&tenant_id=${this.authService.getTenantId()} `
      )
      .withAutomaticReconnect()
      .configureLogging(LogLevel.Information)
      .build());

    connection.start();
    connection.on("send", (data: PendingProcess) => {
      console.log(data);
      if (this.isItemInProcessArray(data.id)) {
        this.updateItemInProcess(data);
      } else {
        this.addItemToProcesses(data);
      }
      if(data.action === "Add All Here" || data.action === "CreatePlan" || data.action === "ConfirmShipmentPlan"){
        this.setSignalResponse(data); 
       } else{
        if (
          data.response.responseType.toLowerCase() === "success" ||
          data.response.responseType.toLowerCase() === "done" ||
          data.response.responseType.toLowerCase() === "error" 
        ) {
          this.setSignalResponse(data);        
          }
      }
    });

    this.headerService.settlementDetail$.pipe(takeUntil(this.destroy$)).subscribe((res)=>{
      this.settlementDetail = res
    })
    this.headerService.amazonShipmentTitle.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{ 
      if (res) {
        this.titleWithShipment = res.shipment;
        if (res.accountType === "Walmart") {
          this.titleWithShipment.url = "https://seller.walmart.com/wfsLite/sendinventory/inbound/order?inboundOrderId="+this.titleWithShipment?.amazonShipmentId;
        } else {
          this.titleWithShipment.url = "https://sellercentral.amazon.com/fba/inbound-shipment/summary/"+this.titleWithShipment?.amazonShipmentId;
        }
      } else {
        this.titleWithShipment = null;
      }
    })


    this.settingsService.GetSelectedPrinter().pipe(takeUntil(this.destroy$)).subscribe((printer: any[]) => {
      this.gridActionService.printer = printer.find((x) => x.printerType === 1);
    });

  }

  signalRWithoutToken(){
    const refreshConnectionHub = (this.hubConnection = new HubConnectionBuilder()
    .withUrl(
      `${environment.apiUrl}/hub/refresh`
    )
    .withAutomaticReconnect()
    .configureLogging(LogLevel.Information)
    .build());
    refreshConnectionHub.start();
    refreshConnectionHub.on("send", (data: PendingProcess) => {
       if(data.action == "Refresh Page" && data.response.responseType.toLowerCase() === "done"){
        this.dialog.open(ConfirmDialogComponent, {
          width: "450px",
          data: {
            title: "Please note!",
            message: "To improve your experience, we implemented an important update. To continue, please save your work and reload the page. Any unsaved data will be lost."
          },
        }).afterClosed().pipe(takeUntil(this.destroy$)).subscribe((confirmation) => {
          if (confirmation == "Confirm") window.location.reload();          
        });
       }
     });
  }

  setSignalResponse(data){
    setTimeout(() => this.removeItemFromProcesses(data.id), 3000);
    this.headerService.pauseSubj$.next(false);
    this.headerService.remoteActionBroadcaster.next(data);
  }
  getAccountByType(){
    const user = JSON.parse(localStorage.getItem("User")) as LoginModel;
    this.accounts = this.settingsService.GetAccountsByType().pipe(
      map(e => e.filter((account: any) => {
        if(user.isShipyard && !user.isPriceYard && !user.isYardener && !user.isPlanYard) return (account.type === 'Amazon' || account.type === 'Walmart') &&  account.isActive;
        else return account.isActive;
      })),
      shareReplay(1),
      tap((e) => {
        localStorage.setItem(StorageKeyEnum.AllAccounts,JSON.stringify(e));
        const needUpdate =e.findIndex(res=>(res.reftoken === 0 && res.type.toLocaleLowerCase() === AccountType.Amazon)) !== -1;  
        this.authService._isAccountActive.next(needUpdate);
        const grouped = this.groupBy(e);
        this.allAccounts = [];
        for (let key of Object.keys(grouped)) {
           this.allAccounts.push(...grouped[key]);
        }
        const accountString = localStorage.getItem(
          StorageKeyEnum.SelectedAccount
        );
        if (accountString) {
          const accountObj = JSON.parse(accountString);
          this.selectedAccount = accountObj;
        } else {
          localStorage.setItem(
            StorageKeyEnum.SelectedAccount,
            JSON.stringify(e[0].name)
          );
          this.selectedAccount = e[0].name;
        }
        this.accountSelected();

        this.allMarketPlaces = this.generateAllMarketPlaces(e);
        this.setAccount();
      })
    );
  }

  setAccount(){
    this.accounts = merge().pipe(
      startWith(""),
      switchMap(() => of(this.allAccounts)),
      map((accounts: any[]) => {
        return accounts;
      })
    );
    this.allAccounts.forEach((el:any) =>{
      this.ordersGridConfigService?.allAccounts.push(el.name);
     });
     
   }

  groupBy(list) {
   return list.reduce(
      (currentValue, next) => {
        if (!currentValue.hasOwnProperty(next.type)) {
          currentValue[next.type] = [];
        }
        currentValue[next.type].push(next);
        return currentValue;
      },
      {}
    );
}
  ngAfterViewInit() {
    this.matSelect.openedChange.pipe(takeUntil(this.destroy$)).subscribe((opened) => {
      if(opened){
      this.matSelect.panel.nativeElement.parentElement.parentElement.style.marginTop ="5px";
      this.matSelect.panel.nativeElement.parentElement.parentElement.className = 'accountDialog cdk-overlay-connected-position-bounding-box';
      }
    });
  }

  isItemInProcessArray(itemId) {
    return (
      this.processes.filter((process: PendingProcess) => process.id === itemId)
        .length > 0
    );
  }

  addItemToProcesses(item: PendingProcess) {
    this.processes.push(item);
  }

  updateItemInProcess(item: PendingProcess) {
    this.processes = mergeArray(this.processes, item);
  }

  removeItemFromProcesses(itemId) {
    this.processes = this.processes.filter((item) => item.id !== itemId);
  }

  accountsChanged() {
    this.accountSelected();
    localStorage.setItem(
      StorageKeyEnum.SelectedAccount,
      JSON.stringify(this.selectedAccount)
    );
    localStorage.removeItem(StorageKeyEnum.PoFilters);
   const index= this.allAccounts.findIndex(
      (res) => res.name == this.selectedAccount
    );
  }

  accountSelected() { 
    this.headerService.accountsSelected.next([this.selectedAccount]);
    if(this.userInfo.isPlanYard || this.userInfo.isShipyard) this.getUnmappedDuplicateSku();
    let account = this.allAccounts.filter(
      (res) => res.name == this.selectedAccount
    );
    this.accountSelectedType(account[0]);
  }

  accountSelectedType(account) {
    localStorage.setItem(StorageKeyEnum.SelectedAccountType,JSON.stringify(account.type));
    this.headerService.accountSelectedType.next([account.type]);
    this.headerService.amazonRegionId.next(account.marketplaceID); 
    this.headerService.accountStore.next(account.storeUrl);   
    this.selectedType=account.type;   
  }

  selectAllMarketPlace() {}

  openUpdatesDialog() {
    this.dialog.open(UpdatesDialogComponent, {
      width: "160px",
      maxHeight: "220px",
      position: {
        top: "47px",
        right: "113px",
      },
      backdropClass: "cdk-overlay-transparent-backdrop",
    });
  }

  generateAllMarketPlaces(accounts) {
    const array = accounts.map((account) => account.type.toLowerCase());
    this.accountTypes = new Set(array);
    this.headerService.accountTypes$.next(this.accountTypes);
  }

  openProcesses() {
    const elementWidth = this.processingElement.nativeElement.offsetWidth;
    const leftOfset = this.processingElement.nativeElement.offsetLeft;

    this.dialog.open(ProcessesDialogComponent, {
      backdropClass: "cdk-overlay-transparent-backdrop",
      panelClass: "process-dialog",
      width: elementWidth + "px",
      position: {
        top: "57px",
        left: leftOfset + "px",
      },
      data: this.processes,
    });
  }

  ngOnDestroy(): void {
    this.authService._isAccountActive.next(null);
    this.matSelect.openedChange.unsubscribe();
    this.destroy$.next();
    this.destroy$.unsubscribe();    
  }

  openDuplicateSku(duplicateSku){
    const dialog = this.dialog.open(DuplicateSkuComponent, {
      width: "601px",
      data: {
        title: duplicateSku.value + " Duplicate Sku's",
        account:duplicateSku.account
      },
    });
    dialog
      .afterClosed()
      .pipe(filter((e) => e === "Confirm"))
      .subscribe((e) => {
        this.getUnmappedDuplicateSku();
      }
  ); 
}

  openMappedSkus(){
    const dialog = this.dialog.open(UnmappedSkusComponent, {
      width: "621px",
      data: {
        title:  "Mapped Sku's with Sync off",
        isWithSyncOff: true,
        productCount: this.mappedWithSyncOffCount
      },
    });
    dialog
      .afterClosed()
      .pipe(filter((e) => e === "Confirm"))
      .subscribe((e) => {
      }
    ); 
  }

  openUnmappedSku(isItemStockWithNoMapping = false,isSkuNotFoundData=false,showDeductShipment=false){
    const title = showDeductShipment ?  this.nonDeductedShipmentCount +' ' + "Shipments Not Deducted" 
     : isItemStockWithNoMapping ? this.itemStockWithNoMappingCount +" Unmapped Products With Stock" : isSkuNotFoundData ?  this.skuNotOnSellerCount + " Skus Not Found" :  this.unMappedSku[0].count+" Unmapped Sku's"
        const dialog = this.dialog.open(UnmappedSkusComponent, {
          width: "621px",
          data: {
            title:  title,
            isItemStockWithNoMapping: isItemStockWithNoMapping,
            productCount: showDeductShipment ?  this.nonDeductedShipmentCount : this.itemStockWithNoMappingCount,
            isSkuNotFoundData,
            nonDeductedShipmentCount: showDeductShipment ? this.nonDeductedShipmentCount : null
          },
        });
        dialog
          .afterClosed()
          .pipe(filter((e) => e === "Confirm"))
          .subscribe((e) => {
          }
      ); 
  }

  getUnmappedDuplicateSku(){
    this.inventoryservice.getuNmappedDuplicatesku(this.selectedAccount).pipe(takeUntil(this.destroy$)).subscribe({
    next: (res:any) => {
      this.unMappedSku = res;
      this.total += this.unMappedSku.length || 0;
    },
    error: (err) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 4000,
          horizontalPosition: 'center',
          data: {
            title: 'Something went wrong',
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
     }
   });
  }

  copy(e: MouseEvent) {
    this.copied = true;
    setTimeout(() => {
      this.copied = false;
    }, 800);
  }
  //generate alll marketplaces
  // value will be array of intergration ID

  getItemStockWithNoMappingCount(){
    this.inventoryservice.getItemStockWithNoMappingCount().pipe(takeUntil(this.destroy$)).subscribe({
    next: (res:any) => {
      this.itemStockWithNoMappingCount = res.count;
      if(this.userInfo.isPlanYard) this.total += 1;
    },
    error: (err) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 4000,
          horizontalPosition: 'center',
          data: {
            title: err?.error?.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
     }
   });
  }

  getMappedWithSyncOffCount(){
    this.inventoryservice.mappedWithSyncOffCount().pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:any) => {
      this.mappedWithSyncOffCount = res.count;
      if(this.userInfo.isPlanYard) this.total +=1;
    },
     error: (err) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 4000,
          horizontalPosition: 'center',
          data: {
            title: err?.error?.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
     }
   });
  }

  refreshNotifications(){
    this.headerService.refreshNotifications$.next(true);
  }
  
  getDuplicateSkuCount() {
    this.inventoryservice.GetDuplicateSkuCount().pipe(takeUntil(this.destroy$)).subscribe({
    next: (res:any) => {
      this.duplicateSkuCount = res;
      this.totalDuplicateSku = this.duplicateSkuCount.map(a => a.value).reduce(function (a, b) {
        return a + b;
      });
    },
    error: (err) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 4000,
          horizontalPosition: 'center',
          data: {
            title: err?.error?.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
     }
   });
  }

  getSetting(){
    const payload= ['IsNewFlow','Use Bins Location'];
    this.settingsService.GetSettings(payload).pipe(takeUntil(this.destroy$)).subscribe({
    next: (res:any) => {
      const IsNewFlow = res.find(
        (x) => x.name === "IsNewFlow"
      );
      this.headerService.isNewFlow= IsNewFlow ? IsNewFlow.isOn : false;

      const binLocation = res.find(
        (x) => x.name === "Use Bins Location"
      );
      this.headerService.useBinLocation= binLocation ? binLocation.isOn : false;

      this.headerService.updatedSetting.next(true);
    },
    error: (err) => {
      this.snackBar.openFromComponent(SnackbarComponent,{
        duration: 3000,
        horizontalPosition: 'center',
        data: {
          title: err?.error?.error[0],
          action: 'Dismiss',
            type: 'error',
        },
      })
     }
   });
  }

  getSkuNotOnSellerCount() {
    this.inventoryservice.getSkuNotOnSellerCount().subscribe({
      next:(res:any)=>{
        this.skuNotOnSellerCount = res.count;
        if(this.userInfo.isPlanYard) this.total +=1;
      }, error:(err)=>{
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 4000,
            horizontalPosition: 'center',
            data: {
              title: err?.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
      }
    })
  }

  getShipmentDeductionAlertCount(){
      this.shipyardService.ShipmentDeductionAlertCount().subscribe({
        next:(res:any)=>{
           this.nonDeductedShipmentCount = res;
      }, error:(err)=>{
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: err.error.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
      }
    })
  }
  getLogisticsScanSetting(){
    this.settingsService.GetLogisticsScanSetting().subscribe({
      next:(res:any)=>{
        this.scanSetting=res;
        this.headerService.scanSetting=res;
      }, error:(err)=>{
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: err?.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
      }
    })
  }
}

interface PendingProcess {
  action: string;
  id: string;
  response: {
    data?:string
    message: string;
    responseType: string;
  };
}

const mergeArray = (arr, obj) =>
  arr && arr.map((t) => (t.id === obj.id ? obj : t));
